module.exports = __webpack_public_path__ + "static/5-d18ccc6c1941298d48c08e76bcdecccd.jpg";